import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { refreshSharedAccessStatus } from './access';
import NoIndexMeta from './NoIndexMeta';

const RequireSecureAccess = ({ children }) => {
  const location = useLocation();
  const [accessState, setAccessState] = useState('checking');

  useEffect(() => {
    let isCurrent = true;

    const checkAccess = async () => {
      const granted = await refreshSharedAccessStatus();

      if (!isCurrent) {
        return;
      }

      setAccessState(granted ? 'granted' : 'denied');
    };

    checkAccess();

    return () => {
      isCurrent = false;
    };
  }, [location.pathname, location.search, location.hash]);

  if (accessState === 'checking') {
    return (
      <section className="py-16 px-6">
        <div className="max-w-3xl mx-auto text-center text-gray-500">Checking secure access...</div>
      </section>
    );
  }

  if (accessState !== 'granted') {
    const encodedTarget = encodeURIComponent(location.pathname + location.search + location.hash);
    return <Navigate to={`/access?next=${encodedTarget}`} replace />;
  }

  return (
    <>
      <NoIndexMeta />
      {children}
    </>
  );
};

export default RequireSecureAccess;
